const userChannelNames = {
    COACH: 'coach',
    CONSUMER: 'consumer',
};

export default userChannelNames;
